import React from "react";

/**
 * Reusable MetaText component for labels, suffixes, and secondary status text.
 * Standardizes the monospaced, light-gray, clinical look.
 *
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The meta text.
 * @param {string} [props.className] - Additional CSS classes.
 * @returns {JSX.Element} MetaText component.
 */
const MetaText = ({ children, className = "" }) => (
    <span className={`text-meta ${className}`}>
        {children}
    </span>
);

export default MetaText;
